import LocalizedStrings from 'react-localization'

let locales = new LocalizedStrings({
  en: {
    pagina1t1: 'Natural Mineral Water: Purity and Freshness at Your Fingertips',
    pagina1d1:
      "Enjoy the purity and freshness of our wide selection of natural mineral waters, ideal for hydrating in a healthy and natural way. Sourced from the purest springs, our mineral waters are rich in essential minerals that help maintain the body's fluid balance. Perfect for any time of the day, our mineral waters are the ideal choice to stay fresh and hydrated.",
    pagina1t2: 'Variety of Syrups: A Touch of Freshness and Sweetness',
    pagina1d2:
      'Make your breaks special with our variety of syrups. Perfect for preparing refreshing and tasty drinks, our syrups are made with high-quality ingredients to offer intense and refreshing flavors. Add them to water or use them as ingredients to create original cocktails and drinks that will impress your guests.',
    pagina1t3: 'Non-Alcoholic Beverages: Refreshing and Quenching Drinks',
    pagina1d3:
      'Experience the pleasure of our wide range of non-alcoholic beverages, perfect for refreshing yourself during any occasion. Made with high-quality ingredients, our beverages offer unique and quenching taste experiences. Enjoy them alone or with friends for moments of pure relaxation.',
    pagina2t1: 'SSD: Speed and Reliability for Your System',
    pagina2d1:
      'Take your computer to the next level with our high-performance SSDs. SSDs offer extraordinary read and write speeds, drastically reducing boot times and improving system responsiveness. With their durability and energy efficiency, SSDs are the ideal choice for those looking to optimize their PC’s performance, whether for work or gaming.',
    pagina2t2: 'RAM: Power and Multitasking Without Limits',
    pagina2d2:
      'Expand your computer’s capabilities with our high-quality RAM. RAM is essential for improving multitasking performance and ensuring smooth operation of demanding applications. Whether you are working on complex projects, playing your favorite video games, or simply browsing the web, powerful RAM ensures your system always responds quickly and efficiently.',
    pagina2t3: 'CPU: The Heartbeat of Your Computer',
    pagina2d3:
      'Discover the power and efficiency of our latest generation CPUs. Designed to deliver exceptional performance, CPUs are the brain of your system, ensuring speed and responsiveness in every operation. Whether you are running complex applications, playing the latest video games, or intensive multitasking, our CPUs ensure smooth and uninterrupted operation, taking your productivity and entertainment to new heights.',
    paragrafo1:
      'Zefiro is a company engaged in the wholesale of beverages, foodstuffs and electronics, focused on providing efficient and reliable services.',
    paragrafo3: {
      titolo: 'What we offer',
      descrizione:
        "We deal in the wholesale of beverages, foodstuffs and electronics. We are the ideal partner for all your company's procurement and distribution needs.",
    },
    paragrafo3Bis: {
      riquadro1: {
        titolo: 'Logistics and Transport',
        descrizione: 'Actively seeking new market and business opportunities.',
      },
      riquadro2: {
        titolo: 'Wholesale Buying and selling of Soft Drinks and Groceries',
        descrizione:
          'Ready to provide detailed and customised quotes instantly.',
      },
      riquadro3: {
        titolo: 'Wholesale Buying and selling of Electronics Products',
        descrizione:
          'We guarantee fast and reliable delivery of your products.',
      },
    },
    paragrafo4: {
      titolo1:
        'Efficiency in motion: customised transport and logistics solutions',
      descrizione1:
        'Welcome to the world of efficiency on the move, where every shipment is handled with care and precision. Our company offers complete transport and logistics solutions, ensuring that every consignment reaches its destination safely and on time.',
      titolo2: 'Customised logistics',
      descrizione2:
        "We create tailor-made solutions for our customers' specific needs, optimising transport processes to maximise efficiency and reduce costs.",
      titolo3: 'Reliability without boundaries',
      descrizione3:
        'Thanks to our global network of partners and suppliers, we ensure timely and safe deliveries anywhere in the world, always maintaining high standards of reliability.',
      titolo4: 'Continuous assistance',
      descrizione4:
        'Our commitment goes beyond simple delivery. We are here to support you every step of the way, ensuring constant and personalised assistance to best meet your needs.',
    },

    paragrafo5: {
      titolo1: 'Taste and quality: the world of wholesale food',
      descrizione1:
        'Welcome to the world of taste and quality, where every product is carefully selected to satisfy the most discerning palates. Our company is engaged in the wholesale of soft drinks and foodstuffs, offering a wide range of products to meet all needs.',
      titolo2: 'Premium selection',
      descrizione2:
        'We offer a careful selection of beverages and foodstuffs from the best manufacturers, guaranteeing only high quality products for our customers.',
      titolo3: 'Logistics efficiency',
      descrizione3:
        'Thanks to efficient logistics and an extensive distribution network, we ensure timely and reliable deliveries at all times, wherever you are.',
      titolo4: 'Commitment to your satisfaction',
      descrizione4:
        'Our main goal is to ensure that every customer is completely satisfied with our products and services. We are ready to listen to your feedback and adapt our offers to meet your needs in an effective and timely manner.',
    },

    paragrafo6: {
      titolo1:
        'Wholesale electronics: innovation and reliability for your business',
      descrizione1:
        'Welcome to the world of wholesale electronics, where innovation meets reliability to provide state-of-the-art solutions for your business. Our company is committed to providing high-quality products and services to meet the needs of the modern electronics market.',
      titolo2: 'Technological innovation',
      descrizione2:
        'We are committed to offering our customers the latest innovations in the electronics industry, ensuring access to cutting-edge products that meet the needs of an ever-changing market.',
      titolo3: 'Customisation of offers',
      descrizione3:
        "We are aware that every customer has different needs. For this reason, we offer customised and flexible solutions, adapting our range of products and services to best meet each customer's specific requirements.",
      titolo4: 'Quality-price ratio',
      descrizione4:
        'Our priority is to offer excellent value for money. We are committed to providing high quality products at competitive prices, thus ensuring tangible added value for our customers.',
    },
    paragrafo7: {
      titolo: 'Choose our professionalism',
      descrizione:
        'If you are looking for reliable and efficient solutions for the wholesale of beverages, food and electronic products, you are in the right place. Contact us today to find out more!',
    },
    contact: 'Contact us',
  },
  cs: {
    pagina1t1: 'Přírodní minerální voda: Čistota a svěžest na dosah ruky',
    pagina1d1:
      'Užijte si čistotu a svěžest naší široké nabídky přírodních minerálních vod, ideální pro zdravou a přirozenou hydrataci. Naše minerální vody pocházejí z nejčistších pramenů a jsou bohaté na esenciální minerály, které pomáhají udržovat rovnováhu tekutin v těle. Perfektní pro každý okamžik dne, naše minerální vody jsou ideální volbou, jak zůstat svěží a hydratovaní.',
    pagina1t2: 'Různé druhy sirupů: Dotek svěžesti a sladkosti',
    pagina1d2:
      'Udělějte své přestávky výjimečnými s naší širokou nabídkou sirupů. Perfektní pro přípravu osvěžujících a chutných nápojů, naše sirupy jsou vyrobeny z vysoce kvalitních surovin a nabízejí intenzivní a osvěžující chutě. Přidejte je do vody nebo je použijte jako přísady pro tvorbu originálních koktejlů a nápojů, které ohromí vaše hosty.',
    pagina1t3: 'Nealkoholické nápoje: Osvěžující a uhasící nápoje',
    pagina1d3:
      'Zažijte potěšení z naší široké nabídky nealkoholických nápojů, ideální pro osvěžení při jakékoliv příležitosti. Vyrobeny z vysoce kvalitních surovin, naše nápoje nabízejí jedinečné a osvěžující chuťové zážitky. Užijte si je sami nebo s přáteli pro chvíle čistého odpočinku.',
    pagina2t1: 'SSD: Rychlost a spolehlivost pro váš systém',
    pagina2d1:
      'Posuňte svůj počítač na vyšší úroveň s našimi výkonnými SSD disky. SSD nabízejí mimořádné rychlosti čtení a zápisu, výrazně zkracují dobu spuštění a zlepšují odezvu systému. Díky své odolnosti a energetické účinnosti jsou SSD ideální volbou pro ty, kteří chtějí optimalizovat výkon svého počítače, ať už pro práci nebo hraní her.',
    pagina2t2: 'RAM: Výkon a multitasking bez omezení',
    pagina2d2:
      'Rozšiřte možnosti svého počítače s naší vysoce kvalitní pamětí RAM. RAM je nezbytná pro zlepšení výkonu při multitaskingu a zajištění plynulého chodu náročných aplikací. Ať už pracujete na složitých projektech, hrajete své oblíbené videohry nebo jen procházíte internet, výkonná paměť RAM zajišťuje, že váš systém vždy reaguje rychle a efektivně.',
    pagina2t3: 'CPU: Tlukot srdce vašeho počítače',
    pagina2d3:
      'Objevte výkon a efektivitu našich nejnovějších procesorů. Navrženy pro poskytování výjimečného výkonu, procesory jsou mozkem vašeho systému, zajišťují rychlost a odezvu při každé operaci. Ať už provozujete složité aplikace, hrajete nejnovější videohry nebo intenzivně multitaskujete, naše procesory zajišťují plynulý a nepřerušovaný chod, což posouvá vaši produktivitu a zábavu na novou úroveň.',
    paragrafo1:
      'Zefiro je společnost zabývající se velkoobchodním prodejem nápojů, potravin a elektroniky, která se zaměřuje na poskytování efektivních a spolehlivých služeb.',
    paragrafo3: {
      titolo: 'Co nabízíme',
      descrizione:
        'Zabýváme se velkoobchodním prodejem nápojů, potravin a elektroniky. Jsme ideálním partnerem pro všechny potřeby vaší společnosti v oblasti nákupu a distribuce.',
    },
    paragrafo3Bis: {
      riquadro1: {
        titolo: 'Logistika a doprava',
        descrizione:
          'Aktivní vyhledávání nových tržních a obchodních příležitostí.',
      },
      riquadro2: {
        titolo:
          'Velkoobchodní nákup a prodej nealkoholických nápojů a potravinářského zboží',
        descrizione:
          'Připraveni okamžitě poskytnout podrobné a přizpůsobené nabídky.',
      },
      riquadro3: {
        titolo: 'Velkoobchodní nákup a prodej produktů elektroniky',
        descrizione: 'Zaručujeme rychlé a spolehlivé dodání vašich produktů.',
      },
    },
    paragrafo4: {
      titolo1: 'Efektivita v pohybu: dopravní a logistická řešení na míru',
      descrizione1:
        'Vítejte ve světě efektivity na cestách, kde je každá zásilka zpracovávána pečlivě a precizně. Naše společnost nabízí kompletní dopravní a logistická řešení, která zajistí, že každá zásilka dorazí na místo určení bezpečně a včas.',
      titolo2: 'Logistika na míru',
      descrizione2:
        'Vytváříme řešení na míru specifickým potřebám našich zákazníků, optimalizujeme přepravní procesy s cílem maximalizovat efektivitu a snížit náklady.',
      titolo3: 'Spolehlivost bez hranic',
      descrizione3:
        'Díky naší globální síti partnerů a dodavatelů zajišťujeme včasné a bezpečné dodávky kamkoli na světě a vždy zachováváme vysoké standardy spolehlivosti.',
      titolo4: 'Průběžná pomoc',
      descrizione4:
        'Náš závazek přesahuje rámec prostého dodání. Jsme zde, abychom vás podporovali na každém kroku a zajistili vám stálou a individuální pomoc, abychom co nejlépe vyhověli vašim potřebám.',
    },

    paragrafo5: {
      titolo1: 'Chuť a kvalita: svět velkoobchodu s potravinami',
      descrizione1:
        'Vítejte ve světě chuti a kvality, kde je každý výrobek pečlivě vybírán tak, aby uspokojil i ty nejnáročnější chuťové buňky. Naše společnost se zabývá velkoobchodním prodejem nealkoholických nápojů a potravin a nabízí široký sortiment výrobků, které uspokojí všechny potřeby.',
      titolo2: 'Prémiový výběr',
      descrizione2:
        'Nabízíme pečlivý výběr nápojů a potravin od nejlepších výrobců, což našim zákazníkům zaručuje pouze vysoce kvalitní produkty.',
      titolo3: 'Efektivita logistiky',
      descrizione3:
        'Díky efektivní logistice a rozsáhlé distribuční síti zajišťujeme vždy včasné a spolehlivé dodávky, ať jste kdekoli.',
      titolo4: 'Závazek k vaší spokojenosti',
      descrizione4:
        'Naším hlavním cílem je zajistit, aby byl každý zákazník s našimi výrobky a službami naprosto spokojen. Jsme připraveni naslouchat vašim připomínkám a efektivně a včas přizpůsobit naši nabídku vašim potřebám.',
    },

    paragrafo6: {
      titolo1:
        'Velkoobchod s elektronikou: inovace a spolehlivost pro vaše podnikání',
      descrizione1:
        'Vítejte ve světě velkoobchodu s elektronikou, kde se inovace setkávají se spolehlivostí a poskytují nejmodernější řešení pro vaše podnikání. Naše společnost se zavázala poskytovat vysoce kvalitní výrobky a služby, které splňují potřeby moderního trhu s elektronikou.',
      titolo2: 'Technologické inovace',
      descrizione2:
        'Našim zákazníkům se snažíme nabízet nejnovější inovace v elektronickém průmyslu a zajistit jim tak přístup ke špičkovým výrobkům, které splňují potřeby neustále se měnícího trhu.',
      titolo3: 'Přizpůsobení nabídek',
      descrizione3:
        'Jsme si vědomi toho, že každý zákazník má jiné potřeby. Proto nabízíme individuální a flexibilní řešení a přizpůsobujeme naši nabídku produktů a služeb tak, aby co nejlépe vyhovovala specifickým požadavkům každého zákazníka.',
      titolo4: 'Poměr kvality a ceny',
      descrizione4:
        'Naší prioritou je nabídnout vynikající poměr ceny a kvality. Snažíme se poskytovat vysoce kvalitní výrobky za konkurenceschopné ceny, a tím zajistit našim zákazníkům hmatatelnou přidanou hodnotu.',
    },
    paragrafo7: {
      titolo: 'Vyberte si naši profesionalitu',
      descrizione:
        'Pokud hledáte spolehlivé a efektivní řešení pro velkoobchodní prodej nápojů, potravin a elektronických výrobků, jste na správném místě. Kontaktujte nás ještě dnes a dozvíte se více!',
    },
    contact: 'Kontaktujte nás',
  },
})

export default locales
